<fui-modal [state]="state" [maxWidth]="'900px'">
    <fui-modal-window>
        <fui-modal-window-toolbar (closed)="cancel()" [title]="'wbo.cash-management.edit.heading.balanceTally'">
        </fui-modal-window-toolbar>
        <fui-modal-window-main>
            <fui-rows>
                <fui-row>
                    <fui-column>
                        <wbo-edit-grid [data]="data" [editable]="!readonly" [removable]="false" [controlsConfig]="{valueInput: ''}">
                            <wbo-text-column field="displayName" [title]="'wbo.cash-management.edit.column.tally.name'"></wbo-text-column>
                            <wbo-numeric-column field="valueInput" [editable]="true" [title]="'wbo.cash-management.edit.column.tally.value'"
                                                [placeholder]="'wbo.cash-management.edit.column.tally.value'"></wbo-numeric-column>
                            <wbo-currency-column field="total" [title]="'wbo.cash-management.edit.column.tally.total'" [width]="100"></wbo-currency-column>
                            <wbo-edit-grid-command *ngIf="!readonly">
                                <fui-commands [title]="'wbo.common.button.clear'">
                                    <fui-command [title]="'wbo.common.button.clear'" (clicked$)="clear()"></fui-command>
                                </fui-commands>
                            </wbo-edit-grid-command>
                        </wbo-edit-grid>
                    </fui-column>
                </fui-row>
                <fui-row>
                    <fui-four-columns>
                        <fui-column>
                        </fui-column>
                        <fui-column>
                        </fui-column>
                        <fui-column>
                            <b [style.text-align]="'right'">{{'wbo.cash-management.edit.message.grandTotal' | translate}}</b>
                        </fui-column>
                        <fui-column>
                            <b [style.text-align]="'right'">{{calculateTotal() | wbo_currency}}</b>
                        </fui-column>
                    </fui-four-columns>
                </fui-row>
            </fui-rows>
        </fui-modal-window-main>
        <fui-modal-window-footer>
            <fui-buttons>
                <wbo-cancel-button (click)="cancel()"></wbo-cancel-button>
                <wbo-ok-button *ngIf="!readonly" (click)="confirm()" [title]="'wbo.common.button.apply'"></wbo-ok-button>
            </fui-buttons>
        </fui-modal-window-footer>
    </fui-modal-window>
</fui-modal>
